import { getPermissionString } from "../userOps/role";
export class PinInListSDK {
    constructor(
        private name: string,
        private creationTime: Date,
        // private ttl: number, // now in minutes
        private expiryTime:Date,
        private allowedPinOps: number[],
        private client: string,
        private Id: Uint8Array = new Uint8Array(0) // default to empty Uint8Array
    ) { }

    public getName(): string {
        return this.name;
    }

    public getCreationTime(): Date {
        return this.creationTime;
    }
    public getExpiryTime(): Date {
        return this.expiryTime;
    }
    public getId(): Uint8Array {
        return this.Id;
    }



    // public getTtl(): number {
    //     return this.ttl;
    // }

    public getAllowedPinOps(): number[] {
        return this.allowedPinOps;
    }

    public static fromProto(proto: any): PinInListSDK {
        const converted_date = new Date(Number(proto.creationTime) * 1000); // convert seconds to ms
        if (isNaN(converted_date.getTime())) {
            throw new Error("Invalid creation_time in proto: " + proto.creation_time);
        }
        // const allowed_pin_ops_converted_to_num=proto.allowed_pin_ops.map(Number);
        // console.log("allowed_pin_ops:", allowed_pin_ops_converted_to_num);
        
        return new PinInListSDK(
            proto.name,
            new Date(Number(proto.creationTime) * 1000), // convert seconds to ms
            new Date(Number(proto.creationTime) * 1000 + Number(proto.ttl) * 1000), // expiryTime = creationTime + ttl (both in seconds, convert to ms)
            // Array.isArray(proto.allowed_pin_ops) ? proto.allowed_pin_ops : []
            Array.isArray(proto.allowedPinOps) ? proto.allowedPinOps.map(Number) : [],
            proto.client || "", // client may not be present in all protos,
            proto.idToClient? new Uint8Array(proto.idToClient) : new Uint8Array(0) // ensure Id is a Uint8Array


        );
    }

    // public toProto(): any {
    //     return {
    //         name: this.name,
    //         creation_time: Math.floor(this.creationTime.getTime() / 1000), // ms to seconds
    //         ttl: this.ttl * 60, // minutes to seconds
    //         allowed_pin_ops: this.allowedPinOps
    //     };
    // }
}
